import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-credit-notes",
    templateUrl: "./credit-notes.component.html",
    styleUrls: ["./credit-notes.component.scss"],
})
export class CreditNotesComponent implements OnInit {
    displayName: any;
    creditNotes = [
        {
            invoice_number: "162002009",
            doc_type: "ZSRD",
            bar_cod: "STVNPO6X22A00246",
            po_number: "",
            invoice__amount: "250,000.00",
            current_status: "Credit Note Processing",
        },
        {
            invoice_number: "272006790",
            doc_type: "ZSRD",
            bar_cod: "STVNPO6X22A00246",
            po_number: "",
            invoice__amount: "1,5500,00.00",
            current_status: "Credit Note Processing",
        },
        {
            invoice_number: "342007983",
            doc_type: "ZSRD",
            bar_cod: "STVNPO6X22A00001",
            po_number: "262002075",
            invoice__amount: "90,000.00",
            current_status: "Credit Note Processing",
        },
    ];

    constructor() {}

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
    }
}
